<template>
  <div>
    <!-- ✅ เลือกรุ่น AI -->
    <div class="ai-model-select">
      <select v-model="selectedModel" class="form-select form-select-sm" @change="updateModel">
        <option v-for="model in aiModels" :key="model" :value="model">
          {{ model }}
        </option>
      </select>
    </div>

  </div>
</template>

<script>
export default {
  computed: {
    credit() {
      return this.$storex.getters.getCredit.toFixed(2);
    }
  },
  data() {
    return {
      aiModels: [
        'gemini-2.5-pro',
        'gemini-2.5-flash',
        'gemini-2.5-flash-lite',
        'gemini-2.5-flash-image',
        'gemini-2.0-flash-001',
        'gemini-2.0-flash-lite-001',
        'gemini-1.5-pro',
        'gemini-1.5-flash',
        // You can also include specialized models if needed:
        // 'gemini-embedding-001',
        // 'text-multilingual-embedding-002'
      ],
      selectedModel: localStorage.getItem('aiModel') || 'gemini-2.5-flash',
    };
  },
  methods: {

    async updateModel() {
      localStorage.setItem('aiModel', this.selectedModel);
      const uid = this.$storex.getters.getUserData.uid

      await this.$http.post(`${process.env.VUE_APP_BACKEND_URL}/api/user/update`, { uid: uid, aiModel: this.selectedModel },)

    }
  }
}
</script>

<style scoped>
.ai-model-select select {
  min-width: 160px;
  font-size: 0.8rem;
}
</style>
